export default "__VITE_ASSET__ClMDoT$m__"